import BaseTabStrip from "./BaseTabStrip";

class NavigationTabStrip extends BaseTabStrip {
  constructor(containerId) {
    super(containerId);
  }
}

module.exports = NavigationTabStrip;